<template>
    <div id="previewType">
        <div class="previewType-tit">
            预览题目类型 
             <el-tooltip class="item" effect="dark" content="此面板仅在预览页面具备，考生不具备此面板" placement="left">
            <span class="el-icon-question"></span>
             </el-tooltip>
        </div>
        <div class="previewType-data">
            <div class="previewType-item flex align-cen">
                <div class="item1"></div>
                <div class="item2">题数</div>
                <div class="item3">分值</div>
            </div>
            <div class="previewType-item flex align-cen" v-for="(item,index) in this.paperJson.questionTypeMapList">
                <div class="item1">
                    {{$util.getTopicType(item.type) || '试卷总数据'}}
                </div>
                <div class="item2">
                    {{item.num}}道
                </div>
                 <div class="item3">
                    {{item.score}}分
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
      props:{
        paperJson:{
            type:Object,
            default: {} // 默认值
        },
    },
    data() {
        return {
            
        }
    },
    created() {
    },
    methods: {
        
    }
}
</script>
<style lang="scss" scoped>
#previewType{
    width: 200px;
    border: 1px solid #ccc;
    position: absolute;
    right: 20px;
    top: 175px;
    border: 1px solid #eee;
    border-radius: 5px;
    box-shadow: 0 4px 8px 0 rgba(7, 17, 27, 0.1);
    background: #fff;
    padding: 20px;
    padding-bottom: 30px;
    .previewType-tit{
        font-size: 16px;
        span{
            cursor: pointer;
        }
    }
    .previewType-data{
        margin-top: 30px;
        .previewType-item{
           div{
            text-align: center;
           }
           .item1{
            width: 45%;
           }
           .item2,.item3{
            width: 22.5%;
           }
        }
    }
}
</style>